import React from "react";
import { Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import imgLocation from "../../assets/images/permission/location.svg";
import imgNotification from "../../assets/images/permission/notification.svg";
import imgAgeVerification from "../../assets/images/permission/age14.png";
import imgAllow from "../../assets/images/permission/allow.png";
import imgDontAllow from "../../assets/images/permission/dont_allow.png";
import imgTerm from "../../assets/images/permission/term.svg";
import imgConsent from "../../assets/images/permission/consent.svg";

const USER_PERMISSIONS: any = [
  {
    id: 1,
    title: "Terms of Service",
    key: "term_of_use",
    icon: imgTerm,
  },
  {
    id: 2,
    title: "Personal Info Consent",
    key: "personal_info",
    icon: imgConsent,
  },
  {
    id: 3,
    title: "Location Services Consent",
    key: "location",
    icon: imgLocation,
  },
  {
    id: 4,
    title: "Event & Promo Notifications",
    key: "event",
    icon: imgNotification,
  },
  {
    id: 5,
    title: "Age Verification (14+)",
    key: "age_verification_over_14",
    icon: imgAgeVerification,
  },
];

const ROLE_PERMISSION: any = {
  0: "Don't Allow",
  1: "Allow"
};

const TermConditionItem = ({ icon, title, value=false }: any) => {
  const { t, i18n } = useTranslation();

  const getPermissionStatus = (status: any) => {
    const value = status === true ? 1 : 0;

    return (
      <div className="cursor-pointer d-flex gap-1 align-items-center whitespace-nowrap">
        <img width={12} height={12} src={status === true ? imgAllow : imgDontAllow} alt={t(ROLE_PERMISSION?.[value])} />
        <div>{t(ROLE_PERMISSION?.[value])}</div>
      </div>
    );
  };

  return (
    <div className="d-flex">
      <div className="d-flex gap-2" style={{width: "230px"}}>
        <div style={{ width: "16px" }}>
          {icon && <img src={icon} alt={t(title)} width={16} />}
        </div>
        <div className="whitespace-nowrap">{t(title)}</div>
      </div>
      
      <div>{getPermissionStatus(value)}</div>
    </div>
  );
};

const TermCondition = ({ conditions }: any) => {
  const { t } = useTranslation();

  return (
    <div className="w-100">
      <Row>
        {USER_PERMISSIONS.map(({ id, title, key, icon }: any) => (
          <React.Fragment key={id} >
            <TermConditionItem
              icon={icon}
              title={title}
              value={conditions?.[key]}
              permissionKey={key}
            />
          </React.Fragment>
        ))}
      </Row>
    </div>
  );
};

export default TermCondition;
